<template>
  <div v-if="stripeStatus=='loaded'"></div>
</template>

<script>


export default {
  name: "StripeConfirmAction",
  props: {
    handleCardPaymentTrigger: {
      type: Number,
      required: false,
      default: 0,
    },
    cardPaymentDetails: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      error: null,
      stripe: null,
    }
  },
  computed: {
    paymentFailed() {
      return this.error != null;
    },
    stripeStatus() {
      return this.$store.getters.stripeStatus
    },
  },
  methods: {
    handleError(error) {
      this.error = error.message;
      this.$emit('on-error', this.error);
    },

    resetError() {
      this.error = null;
    },

    handleCardPayment() {

      const {clientSecret} = this.cardPaymentDetails
      this.stripe.retrievePaymentIntent(clientSecret).then((result) => {
        if (result.error || result.paymentIntent.status == "requires_payment_method") {
          this.$emit('on-requires-payment-method')
        } else {
          this.stripe.handleCardPayment(clientSecret).then( (result) => {
            if (result.error) {
              this.handleError({message: result.error.message})
            } else {
              this.$emit('on-handle-card-payment', result)
            }
          }).catch(err => {
            this.handleError({message: err})
          });
        }
      });

    },
    initStripeInstance() {
      if (!this.stripe) {
        this.stripe = window.Stripe(process.env.STRIPE_PK);
      }
      this.$emit('on-stripe-ready')
    }
  },
  mounted() {
    if (this.stripeStatus == 'none') {
      this.$store.dispatch('loadStripeLib')
    } else if (this.stripeStatus == 'loaded') {
      this.initStripeInstance();
    }
  },
  components: {
  },
  watch: {
    stripeStatus(newVal) {
      if (newVal=="loaded") {
        this.initStripeInstance();
      }
    },
    handleCardPaymentTrigger(newVal, _oldVal) {
      if (newVal>0) {
        this.handleCardPayment();
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.stripe-elements-wrapper {
  border-bottom: 2px solid $border-color;
  padding: 10px 0 15px 0;
}

</style>